import { render, staticRenderFns } from "./PatientGoal.vue?vue&type=template&id=678d89ae&scoped=true&lang=html"
import script from "./PatientGoal.vue?vue&type=script&lang=js"
export * from "./PatientGoal.vue?vue&type=script&lang=js"
import style0 from "./PatientGoal.vue?vue&type=style&index=0&id=678d89ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d89ae",
  null
  
)

export default component.exports